import { useEffect, useState } from 'react';
import { useStore } from '../../store';

export enum SupportedSearchParams {
  OM = 'om',
}

interface InitialSearchParamsProps {
  queryKey: SupportedSearchParams;
  shouldClearParamAfterGet?: boolean;
}

export const useGetInitialSearchParam = (props: InitialSearchParamsProps) => {
  const { queryKey, shouldClearParamAfterGet = false } = props;
  const initialSearchParams = useStore((state) => state.searchParams);
  const setSearchParams = useStore((state) => state.setSearchParams);

  const [queryValue, setQueryValue] = useState<string | null>(null);

  useEffect(() => {
    const searchParamsObject = new URLSearchParams(initialSearchParams);
    const qValue = searchParamsObject.get(queryKey);
    if (qValue) {
      setQueryValue(qValue);
      if (shouldClearParamAfterGet) {
        searchParamsObject.set(queryKey, '');
        setSearchParams(searchParamsObject.toString());
      }
    }
  }, [queryKey]);
  return { queryValue };
};
